<mat-toolbar color="custom" id="main-menu-header">
	<a [routerLink]="[homeUrl]">
		<img src="{{logourl}}" class="logo" />
	</a>
	<a *ngIf="!isMobile" mat-button [routerLink]="[homeUrl]" [routerLinkActive]="'my-active'" matTooltip="Home">
		<fa-icon [icon]="['fas', 'home']"></fa-icon>
	</a>
	<button mat-button [ngbPopover]="popContent1" placement="bottom" popoverClass="popup-menu" matTooltip="Menu">
		<fa-icon [icon]="['fas', 'th']"></fa-icon>
	</button>
	<ng-template #popContent1>
		<div class="row">
			<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="[homeUrl]"
				[routerLinkActive]="'popup-menu-active'">
				<p class="sub-menu-p">
					<fa-icon [icon]="['fas','home']"></fa-icon>
					<br />
					Home
				</p>
			</a>
			<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/company-list']"
				[routerLinkActive]="'popup-menu-active'">
				<p class="sub-menu-p">
					<fa-icon [icon]="['fas','building']"></fa-icon>
					<br />
					Company
				</p>
			</a>
			<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/profile-list']"
				[routerLinkActive]="'popup-menu-active'">
				<p class="sub-menu-p">
					<fa-icon [icon]="['fas','user-plus']"></fa-icon>
					<br />
					Profile
				</p>
			</a>
			<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/scale-list']"
				[routerLinkActive]="'popup-menu-active'">
				<p class="sub-menu-p">
					<fa-icon [icon]="['fas','balance-scale']"></fa-icon>
					<br />
					Scale
				</p>
			</a>
			<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/rank-list']"
				[routerLinkActive]="'popup-menu-active'">
				<p class="sub-menu-p">
					<fa-icon [icon]="['fas','star']"></fa-icon>
					<br />
					Rank
				</p>
			</a>
			<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/question-list']"
				[routerLinkActive]="'popup-menu-active'">
				<p class="sub-menu-p">
					<fa-icon [icon]="['fas','question-circle']"></fa-icon>
					<br />
					Question Bank
				</p>
			</a>
			<!-- <a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
				[routerLink]="['/app/question-translation']" [routerLinkActive]="'popup-menu-active'">
				<p class="sub-menu-p">
					<fa-icon [icon]="['fas','cogs']"></fa-icon>
					<br />
					Questions
				</p>
			</a> -->
			<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/category-list']"
				[routerLinkActive]="'popup-menu-active'">
				<p class="sub-menu-p">
					<fa-icon [icon]="['fas','list-alt']"></fa-icon>
					<br />
					Category
				</p>
			</a>
		</div>
	</ng-template>
	<span class="example-spacer"></span>
	<button mat-button [matMenuTriggerFor]="mymenu">
		<ng-container *ngIf="!isMobile">
			<!-- <fa-icon [icon]="['fas', 'user-circle']" class="me-1"></fa-icon> -->
			{{user_name}}
			<fa-icon [icon]="['fas', 'angle-down']" class="ms-1"></fa-icon>
		</ng-container>
		<fa-icon *ngIf="isMobile" [icon]="['fas', 'user-circle']"></fa-icon>
	</button>
	<mat-menu #mymenu="matMenu">
		<!-- <button mat-menu-item (click)="resetPasswordModal()">
			<fa-icon [icon]="['fas', 'lock']"></fa-icon>
			Change Password
		</button> -->
		<button mat-menu-item (click)="logoutUser()">
			<fa-icon [icon]="['fas', 'sign-out-alt']" [flip]="'horizontal'"></fa-icon>
			Logout
		</button>
	</mat-menu>
</mat-toolbar>
<div class="main-content" id="page-content-container-common" [@routeAnimations]="prepareRoute(o)">
	<router-outlet #o="outlet"></router-outlet>
	<br />
</div>
<a *ngIf="showScrollBtn" (click)="scrollToTop()" id="scrollToTopButton" matTooltip="Scroll to top">
	<fa-icon [icon]="['fas', 'angle-up']" style="font-size: 15px;"></fa-icon>
</a>
<div class="modal fade" id="changePasswordModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<form class="form-horizontal" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()"
				#passform="ngForm">
				<div class="modal-header">
					<h4 class="modal-title" id="modal-basic-title">Change Password</h4>
					<button type="button" class="btn-close" aria-label="Close" (click)="clearResetPassword()"></button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-4">
							<mat-form-field appearance="outline">
								<mat-label>New Password</mat-label>
								<input type="password" matInput id="password_nav" formControlName="password"
									name="password">
								<mat-error
									*ngIf="f.password.invalid && (passform.submitted || f.password.touched || f.password.dirty)">
									<span *ngIf="f.password.errors?.required">
										Required
									</span>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="col-sm-4">
							<mat-form-field appearance="outline">
								<mat-label>Confirm Password</mat-label>
								<input type="password" matInput id="confirmPassword_nav"
									formControlName="confirmPassword" name="confirmPassword">
								<mat-error
									*ngIf="f.confirmPassword.invalid && (passform.submitted || f.confirmPassword.touched || f.confirmPassword.dirty)">
									<span *ngIf="f.confirmPassword.errors?.required">
										Required
									</span>
								</mat-error>
							</mat-form-field>
							<mat-error
								*ngIf="resetPasswordForm.errors && (passform.submitted || f.confirmPassword.touched)">
								<p *ngIf="resetPasswordForm.errors?.passwordNotMatch">
									Password and Confirm Password not matched!
									<fa-icon [icon]="['fas', 'times']"></fa-icon>
								</p>
							</mat-error>
						</div>
						<div class="col-sm-4">
							<div *ngIf="f.password.invalid && (passform.submitted || f.password.touched)" type="danger">
								<p [ngClass]="f.password.errors?.minlengtherror?'text-danger':'text-success'">
									Must be atleast 8 characters long.
								</p>
								<p [ngClass]="f.password.errors?.specialcharerror?'text-danger':'text-success'">
									Must have atleast 1 special character.
								</p>
								<p [ngClass]="f.password.errors?.uppercaseerror?'text-danger':'text-success'">
									Must have atleast 1 upper case character.
								</p>
								<p [ngClass]="f.password.errors?.lowercaseerror?'text-danger':'text-success'">
									Must have atleast 1 lower case character.
								</p>
								<p [ngClass]="f.password.errors?.digiterror?'text-danger':'text-success'">
									Must have atleast 1 digit.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-outline-primary btn-sm">Reset</button>
					<button type="button" class="btn btn-outline-warning btn-sm" data-dismiss="modal"
						(click)="clearResetPassword();">Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>